import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollReveal } from "./ScrollReveal";
import keywordResearchImg from "@/assets/keyword_research.png";
import nexisAiImg from "@/assets/nexis_ai.png";
import monetisationAiImg from "@/assets/monetisation_ai.png";
import salesPageBuilderImg from "@/assets/sales_page_builder.png";

const steps = [
  {
    number: "1",
    title: "DISCOVER",
    description: "Find what your audience is searching for with real keyword data.",
    image: keywordResearchImg,
    gradient: "linear-gradient(135deg, #F3E8FF 0%, #EDE9FE 100%)",
  },
  {
    number: "2",
    title: "CREATE",
    description: "Generate scripts, video ideas, and content optimised for your niche.",
    image: nexisAiImg,
    gradient: "linear-gradient(135deg, #FFF7ED 0%, #FEF3C7 100%)",
  },
  {
    number: "3",
    title: "MONETISE",
    description: "Build a complete digital product in one click — ebook, course, or template.",
    image: monetisationAiImg,
    gradient: "linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%)",
  },
  {
    number: "4",
    title: "LAUNCH",
    description: "Create your sales page and email funnel, ready to launch.",
    image: salesPageBuilderImg,
    gradient: "linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)",
  },
];

export const FourStepsSection = () => {
  return (
    <section className="relative" style={{ background: "#FFFFFF", padding: "80px 0" }}>
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <ScrollReveal>
          <div className="text-center mb-10 md:mb-14">
            <h2
              className="font-display mb-3"
              style={{ color: "#111827", fontSize: "clamp(24px, 3.5vw, 36px)", fontWeight: 800, lineHeight: 1.2 }}
            >
              From First Follower to First Sale in{" "}
              <span style={{ color: "#F59E0B" }}>4 Steps</span>
            </h2>
            <p style={{ color: "#6B7280", fontSize: "16px" }}>
              One system. Four steps. Works at any audience size.
            </p>
          </div>
        </ScrollReveal>

        <div
          className="max-w-6xl mx-auto"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
          }}
        >
          {steps.map((step, i) => (
            <ScrollReveal key={i} delay={i * 100}>
              <div
                style={{
                  borderRadius: "16px",
                  overflow: "hidden",
                  background: "#FFFFFF",
                  border: "1px solid #F0F0F0",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 6px 24px rgba(0,0,0,0.04)",
                }}
              >
                {/* Coloured zone */}
                <div
                  className="relative flex items-center justify-center"
                  style={{
                    background: step.gradient,
                    height: "220px",
                  }}
                >
                  <img
                    src={step.image}
                    alt={`Step ${step.number}: ${step.title}`}
                    style={{
                      maxWidth: "85%",
                      borderRadius: "12px",
                      boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                      transform: "rotate(-2deg) translateY(10px)",
                    }}
                    loading="lazy"
                  />
                </div>

                {/* Text area */}
                <div style={{ padding: "0 20px 20px" }}>
                  <p style={{ fontWeight: 700, fontSize: "16px", color: "#111827", marginTop: "20px" }}>
                    Step {step.number}: {step.title}
                  </p>
                  <p style={{ fontWeight: 400, fontSize: "14px", color: "#6B7280", lineHeight: 1.5, marginTop: "6px" }}>
                    {step.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Responsive grid override */}
        <style>{`
          @media (max-width: 1024px) {
            .max-w-6xl > div { grid-template-columns: repeat(2, 1fr) !important; }
          }
          @media (max-width: 640px) {
            .max-w-6xl > div { grid-template-columns: 1fr !important; }
            .max-w-6xl > div > div > div:first-child { height: 180px !important; }
          }
        `}</style>

        <div className="flex justify-center mt-10 md:mt-14">
          <a href="#pricing">
            <button
              className="group flex items-center gap-2 transition-all duration-200 hover:scale-[1.03] active:scale-[0.97]"
              style={{
                background: "#7C3AED",
                color: "white",
                padding: "14px 32px",
                borderRadius: "12px",
                fontWeight: 700,
                fontSize: "16px",
                border: "none",
                cursor: "pointer",
              }}
            >
              Start Your Free Trial
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};
